import React from 'react';
import './experience.scss'

const Experience = () => {
	const ExperienceData = [
		{
			id: 1,
			company: "Tech Solutions Inc.",
			position: "Frontend Developer Intern",
			startYear: 2016,
			endYear: 2017,
			location: "New Delhi, India",
			Description: "Assisted senior developers in building responsive web applications using HTML, CSS, and JavaScript. Gained practical exposure to Agile workflows and debugging techniques.",
		},
		{
			id: 2,
			company: "Creative Minds Pvt. Ltd.",
			position: "Junior Frontend Developer",
			startYear: 2017,
			endYear: 2019,
			location: "Bangalore, India",
			Description: "Worked on React.js projects, optimized website performance, and collaborated with UI/UX teams to deliver pixel-perfect designs.",
		},
		{
			id: 3,
			company: "NextGen Web Solutions",
			position: "Frontend Developer",
			startYear: 2019,
			endYear: 2022,
			location: "Pune, India",
			Description: "Developed complex dashboards and reusable React components. Improved app performance by 30% and mentored junior developers.",
		},
		{
			id: 4,
			company: "SuperCodingBits",
			position: "Senior Frontend Engineer",
			startYear: 2022,
			endYear: 2024,
			location: "Remote",
			Description: "Leading frontend projects using React.js, React Native, and SCSS. Responsible for architecting scalable UI systems, code reviews, and collaborating with product teams to ship high-quality applications.",
		}
	];
	
	
	return (
		<>
			<div className="mainExperience">
				<div className="ExperienceTitle">
					<h3>Experience</h3>
				</div>
				
				<div className="subExperience">
					{
						ExperienceData.map ((education) => (
							<div className="Experience">
								<p className="Timeline">{education.startYear} - {education.endYear}</p>
								<div className="ExperienceLedtSection">
									<h3>{education.company}</h3>
									<p className="WorkPosition">{education.position} ({education.location})</p>
								</div>
								<div className="ExperienceRightSection">
									<p>{education.Description}</p>
								</div>
							</div>
						))
					}
				</div>
			</div>
		</>
	);
};

export default Experience;